import { useAppTranslation } from '@hooks/useAppTranslation';
import { H5, YStack } from 'tamagui';
import { LoginActionButton } from './LoginActionButton';

export function LoginFormCard(): React.ReactNode {
  const { t } = useAppTranslation();

  return (
    <YStack
      backgroundColor="$background"
      padding="$true"
      width="80%"
      alignItems="stretch"
      gap="$6"
    >
      <H5 textAlign="center">{t('login.welcome')}</H5>
      <LoginActionButton />
    </YStack>
  );
}
